<template>
    <div class=" corpo-pix">    

        <!-- o qrcode  nesta div  -->
         <div style="color: black">
             
             <p style="margin-top: 25px;">O pagamento deve ser feito ate às: <strong>{{ this.horarioDaCompraLimite }}</strong>h</p>

         </div>

        <div id="canvas" ref="canvasRef" class="qrcode-pix"></div>
        <div style="margin-top: 10px;">
            <button class="button-copia-cod" v-if="!isCopiado" @click="onClickCopiarCodigo">Copiar código</button>
            <button class="button-copia-cod" v-if="isCopiado" @click="onClickCopiarCodigo"> <img src="../../assets/icons/ic-check.png" alt=""><span>Copiado!</span></button>
        </div>
    </div>
</template> 

<script>
/* eslint-disable */
import { apiMercadoPagoBuscarStatusPagamento } from '@/api/ApiMercadoPago'
import Swal from 'sweetalert2'

export default { 
    name: "MpStatusScreenPix",

    props: {
        paymentId: null,
        pix_data: String,
        data_hora_qrcode: String, // formato "2025-01-06T13:48:25.405Z"
        cnpj: null,
        numeroEmpresaFK: null, //
    },
    
    data() {
        return  {
            isDestroyed: false,
            isCopiado: false,
            contagem: null,
        }
    },

    created() {
        setarCores(this.$store.state.cor1, this.$store.state.cor2,this.$store.state.corTexto)
    },

    mounted() {
        this.qrcodar()
    },

    beforeDestroy() {
        this.destruirComponente()
    },

    computed: {
        tempoLimite() {
            let datacomrpapedido = new Date(this.data_hora_qrcode)
            return  new Date( datacomrpapedido.setSeconds(datacomrpapedido.getSeconds() + 300))
        },
        horarioDaCompra() {
            return Intl.DateTimeFormat('pt-BE', {hour: "2-digit", minute: "2-digit"}).format(new Date(this.data_hora_qrcode))
        },
        horarioDaCompraLimite() {
            return Intl.DateTimeFormat('pt-BE', {hour: "2-digit", minute: "2-digit"}).format(this.tempoLimite)
        },
    },

    methods: {
        onClickCopiarCodigo() {
            navigator.clipboard.writeText(this.pix_data);
            this.isCopiado = true;
        },
        qrcodar() {
            const qrCode = new  window.QRCodeStyling({
                width: 150,
                height: 150,
                type: "svg",
                data: this.pix_data,
                // image: "https://upload.wikimedia.org/wikipedia/commons/5/51/Facebook_f_logo_%282019%29.svg",
                dotsOptions: {
                    color: "black",
                    type: "rounded" 
                },
                backgroundOptions: {
                    color: "#fff",
                },
                imageOptions: {
                    crossOrigin: "anonymous",
                    margin: 0
                }
            });

            const ddd =this.$refs.canvasRef
            qrCode.append(ddd)
        },



        destruirComponente() {
            this.isDestroyed = true
        },

        formatarTempoParaMinESegu(tempoEmDate) {
            return Intl.DateTimeFormat('pt-BE', {hour: "2-digit", minute: "2-digit"}).format(tempoEmDate)
        },

    }

}
</script>

<style scoped>
h4, h5,  p { 
    color: black;
}

.corpo-pix p {
    margin: 5px;
}

button img {
    margin-right: 10px;
    height: 25px;
    filter: invert(100%);
}

button {
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: center;
    align-content: center;
    align-items: center;
}

#statusScreenBrick_container, .corpo-pix{
    margin-inline: 0px;
}

.button-copia-cod{
    border-radius: 5px;
    width: 200px;
    height: 50px;
    font-weight: bold;
    margin:0 auto
}
</style>